module.exports = __webpack_public_path__ + "static/iosMasterpassBanner-0c8b31cc7b41b0da2ab0a87862921a70.png";